(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const surface = document.querySelector('.seronine-header-scroll-surface-20260907');
    const categories = document.querySelector('.seronine-dawn-desktop-category-nav-20260830');
    if (!surface || !categories) return;
    const desktop = window.matchMedia('(min-width: 990px)');
    let frame = 0;
    const sync = () => {
      frame = 0;
      const show = desktop.matches && window.scrollY > 0 &&
        categories.getBoundingClientRect().top <= surface.getBoundingClientRect().bottom;
      surface.classList.toggle('is-visible', show);
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(sync); };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('pageshow', schedule);
    desktop.addEventListener('change', schedule);
    sync();
  })();

  (() => {
    const overlay = document.querySelector('[data-seronine-search-overlay-20260905]');
    const input = document.querySelector('[data-seronine-search-input-20260905]');
    const clear = document.querySelector('[data-seronine-search-clear-20260905]');
    const results = document.querySelector('[data-seronine-search-results-20260905]');
    if (!overlay || !input || !clear || !results) return;

    const triggers = [...document.querySelectorAll('[data-seronine-search-toggle-20260905]')];
    triggers.forEach((trigger) => {
      trigger.setAttribute('aria-controls', overlay.id);
      trigger.setAttribute('aria-expanded', 'false');
    });
    let requestTimer, searchAbort, closeTimer, returnFocus, requestVersion = 0;
    let savedScroll = 0, bodyStyles, inertStates = [];
    const mobile = window.matchMedia('(max-width: 989px)');
    const syncViewport = () => {
      const top = mobile.matches ? 64 : 104;
      const height = window.visualViewport?.height || window.innerHeight;
      overlay.style.setProperty('--search-available-height', `${Math.max(100, height - top)}px`);
    };
    window.visualViewport?.addEventListener('resize', syncViewport);
    window.addEventListener('resize', syncViewport, { passive: true });
    const cancelRequest = () => {
      window.clearTimeout(requestTimer); searchAbort?.abort(); requestVersion++;
      results.classList.remove('is-loading'); results.setAttribute('aria-busy', 'false');
    };
    const clearResults = () => { cancelRequest(); results.replaceChildren(); };
    const restorePage = () => {
      if (!bodyStyles) return;
      document.documentElement.classList.remove('seronine-search-open-20260905');
      for (const [key, value] of Object.entries(bodyStyles)) document.body.style[key] = value;
      bodyStyles = null;
      inertStates.forEach(([node, value]) => { node.inert = value; }); inertStates = [];
      window.scrollTo({ top: savedScroll, behavior: 'instant' });
    };
    const setSearch = (open, trigger) => {
      window.clearTimeout(closeTimer);
      if (open) {
        if (overlay.classList.contains('is-open')) { input.focus({ preventScroll: true }); return; }
        document.dispatchEvent(new CustomEvent('seronine:close-menu-for-search-20260907'));
        returnFocus = trigger || document.activeElement;
        if (!bodyStyles) {
          savedScroll = window.scrollY;
          bodyStyles = Object.fromEntries(['position','top','width','overflow'].map(key => [key,document.body.style[key]]));
          if (mobile.matches) {
            document.body.style.position = 'fixed'; document.body.style.top = `-${savedScroll}px`; document.body.style.width = '100%';
          }
          inertStates = [...document.querySelectorAll('#MainContent, .shopify-section-group-footer-group')].map(node => [node,node.inert]);
          inertStates.forEach(([node]) => { node.inert = true; });
        }
        document.documentElement.classList.add('seronine-search-open-20260905');
        overlay.inert = false; syncViewport();
        overlay.classList.remove('is-closing'); overlay.classList.add('is-open');
        overlay.setAttribute('aria-hidden', 'false');
        triggers.forEach(node => node.setAttribute('aria-expanded','true'));
        // Keep focus inside the user's click event so mobile browsers can open the keyboard.
        input.focus({ preventScroll: true });
        if (input.value.trim()) updateResults();
      } else {
        if (!overlay.classList.contains('is-open')) return;
        cancelRequest(); input.blur();
        overlay.classList.remove('is-open'); overlay.classList.add('is-closing');
        overlay.inert = true; overlay.setAttribute('aria-hidden', 'true');
        triggers.forEach(node => node.setAttribute('aria-expanded','false'));
        returnFocus?.focus({ preventScroll: true });
        closeTimer = window.setTimeout(() => { overlay.classList.remove('is-closing'); restorePage(); }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 400);
      }
    };
    const escapeHtml = value => String(value).replace(/[&<>'"]/g, character => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', "'":'&#39;', '"':'&quot;' })[character]);
    const brandImages = JSON.parse(document.getElementById('seronine-search-images-20260907')?.textContent || '{}');
    const searchRoute = overlay.querySelector('form').getAttribute('action');
    const normalizeSearch = value => {
      let term = value.normalize('NFKC').trim().toLowerCase();
      const aliases = {'连帽卫衣':'hoodie','牛仔裤':'jeans','长袖':'long sleeve','短袖':'t-shirt','帽衫':'hoodie','卫衣':'hoodie','夹克':'jacket','外套':'jacket','皮衣':'leather jacket','裤子':'pants','帽子':'cap','套装':'set','上衣':'top','黑色':'black','白色':'white','豹纹':'leopard','拉链':'zip','蜡涂层':'wax','t恤':'t-shirt'};
      for (const [from, to] of Object.entries(aliases)) term = term.split(from).join(` ${to} `);
      return term.replace(/\b(ctx|var|ser)[\s-]*(\d+)/g, '$1-$2').replace(/\s+/g, ' ').trim();
    };
    const searchScore = (product, query) => {
      const title = product.title.toLowerCase();
      const compact = value => value.replace(/[^a-z0-9]/g, '');
      const exactCode = title.split('|')[0].split('｜')[0].trim();
      if (compact(exactCode) === compact(query)) return 1000;
      if (title.includes(query)) return 100;
      return query.split(/\s+/).filter(word => title.includes(word)).length * 10;
    };
    const allLink = query => `<a class="seronine-search-overlay-20260905__all" href="${escapeHtml(searchRoute)}?type=product,page&q=${encodeURIComponent(normalizeSearch(query))}"><span>Search for “${escapeHtml(query)}”</span><span aria-hidden="true">→</span></a>`;
    const updateResults = async () => {
      const query = input.value.trim();
      cancelRequest();
      if (!query || !overlay.classList.contains('is-open')) { results.replaceChildren(); return; }
      const version = requestVersion;
      const searchTerm = normalizeSearch(query);
      searchAbort = new AbortController();
      results.classList.add('is-loading'); results.setAttribute('aria-busy','true');
      try {
        const response = await fetch(`${searchRoute}/suggest.json?q=${encodeURIComponent(searchTerm)}&resources[type]=product,page&resources[limit]=10&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag`, { signal: searchAbort.signal });
        if (!response.ok) throw new Error('Search request failed');
        const payload = await response.json();
        if (version !== requestVersion || input.value.trim() !== query || !overlay.classList.contains('is-open')) return;
        const products = (payload?.resources?.results?.products || []).sort((a,b) => searchScore(b, searchTerm) - searchScore(a, searchTerm)).slice(0, 3);
        const pages = (payload?.resources?.results?.pages || []).slice(0, 2);
        const productRows = products.map(product => {
          const imageUrl = brandImages[product.handle] || product.featured_image?.url || product.image;
          const image = imageUrl ? `<img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(product.title)}" width="300" height="450" loading="lazy">` : '<span></span>';
          return `<a class="seronine-search-overlay-20260905__result" href="${escapeHtml(product.url)}">${image}<span>${escapeHtml(product.title)}</span></a>`;
         }).join('');
        const pageRows = pages.map(page => `<a class="seronine-search-overlay-20260905__page" href="${escapeHtml(page.url)}">${escapeHtml(page.title)}</a>`).join('');
        results.innerHTML = (products.length ? `<section class="seronine-search-overlay-20260905__group" aria-label="Products"><h2 class="seronine-search-overlay-20260905__heading">Products</h2>${productRows}</section>` : '') + (pages.length ? `<section class="seronine-search-overlay-20260905__group" aria-label="Pages"><h2 class="seronine-search-overlay-20260905__heading">Pages</h2>${pageRows}</section>` : '') + (!products.length && !pages.length ? '<span class="seronine-search-overlay-20260905__empty">No results found</span>' : '') + allLink(query);
        results.scrollTop = 0;
      } catch (error) {
        if (error.name !== 'AbortError' && version === requestVersion) results.innerHTML = `<span class="seronine-search-overlay-20260905__empty">Search preview is unavailable. View all results below.</span>${allLink(query)}`;
      } finally {
        if (version === requestVersion) { results.classList.remove('is-loading'); results.setAttribute('aria-busy','false'); }
      }
    };
    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-seronine-search-toggle-20260905], .header__search summary');
      if (trigger) { event.preventDefault(); event.stopPropagation(); setSearch(!overlay.classList.contains('is-open'),trigger); return; }
      if (event.target.closest('[data-seronine-search-close-20260905]') || event.target === overlay) { setSearch(false); return; }
      if (event.target.closest('[data-seronine-search-clear-20260905]')) {
        input.value = ''; clear.classList.remove('is-visible'); clearResults(); input.focus({ preventScroll: true });
      }
      if (overlay.classList.contains('is-open') && event.target.closest('[data-seronine-menu-toggle-20260906]')) setSearch(false);
    }, true);
    input.addEventListener('input', event => {
      cancelRequest(); clear.classList.toggle('is-visible', Boolean(input.value));
      if (!input.value.trim()) { results.replaceChildren(); return; }
      if (!event.isComposing) requestTimer = window.setTimeout(updateResults, 200);
    });
    input.addEventListener('compositionend', () => { cancelRequest(); requestTimer = window.setTimeout(updateResults, 200); });
    overlay.querySelector('form').addEventListener('submit', event => { if (!input.value.trim()) { event.preventDefault(); input.focus(); } else { input.value = normalizeSearch(input.value); } });
    document.addEventListener('keydown', event => {
      if (!overlay.classList.contains('is-open')) return;
      if (event.key === 'Escape') { event.preventDefault(); event.stopImmediatePropagation(); setSearch(false); return; }
      if (event.key !== 'Tab') return;
      const controls = [...overlay.querySelectorAll('input,button,a[href]')].filter(node => node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden');
      const first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && (document.activeElement === first || !overlay.contains(document.activeElement))) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !overlay.contains(document.activeElement))) { event.preventDefault(); first?.focus(); }
    }, true);
    window.addEventListener('pagehide', restorePage);
  })();

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  (() => {
    const menu = document.querySelector('[data-seronine-season-menu-20260906]');
    const triggers = [...document.querySelectorAll('[data-seronine-menu-toggle-20260906]')];
    if (!menu || !triggers.length) return;

    const countryToggle = menu.querySelector('[data-seronine-country-toggle-20260906]');
    const countryPanel = menu.querySelector('.seronine-season-menu-20260906__country-panel');
    const countryForm = menu.querySelector('#SeronineSeasonMenuCountryForm');
    const countrySelect = menu.querySelector('[data-seronine-country-select-20260906]');
    const countryValue = menu.querySelector('[data-seronine-country-value-20260906]');
    const countryUpdate = menu.querySelector('[data-seronine-country-update-20260906]');
    const mobileShopToggle = menu.querySelector('[data-seronine-mobile-shop-toggle-20260906]');
    const mobileSeasonBack = menu.querySelector('[data-seronine-mobile-season-back-20260906]');
    const seasonsNav = menu.querySelector('.seronine-season-menu-20260906__seasons-nav');

    const aboutToggle = menu.querySelector('[data-seronine-about-toggle-20260907]');
    const aboutPanel = menu.querySelector('.seronine-menu-about-20260907');
    const desktop = window.matchMedia('(min-width: 750px)');
    const panel = menu.querySelector('.seronine-season-menu-20260906__panel');
    let returnFocus;
    let closeTimer;
    const focusControl = (control) => control?.focus({ preventScroll: true });
    const setCountryList = (open) => {
      menu.classList.toggle('is-country-list-open', open);
      countrySelect?.setAttribute('aria-expanded', String(open));
    };
    const setCountryPanel = (open) => {
      menu.classList.toggle('is-country-open', open);
      countryPanel?.setAttribute('aria-hidden', String(!open));
      if (countryPanel) countryPanel.inert = !open;
      countryToggle?.setAttribute('aria-expanded', String(open));
      // Keep off-screen layers out of the keyboard path without changing content.
      [...panel.children].filter((node) => node !== countryPanel).forEach((node) => { node.inert = open; });
      if (!open) setCountryList(false);
      if (menu.classList.contains('is-open')) focusControl(open ? countrySelect : countryToggle);
    };
    const setAboutPanel = (open) => {
      const show = open && Boolean(aboutPanel);
      menu.classList.toggle('is-about-open', show);
      aboutPanel?.setAttribute('aria-hidden', String(!show));
      if (aboutPanel) aboutPanel.inert = !show;
      if (show) {
        aboutPanel.scrollTop = 0;
        menu.classList.remove('is-season-level');
        mobileShopToggle?.setAttribute('aria-expanded', 'false');
        seasonsNav?.setAttribute('aria-hidden', 'true');
        if (seasonsNav) seasonsNav.inert = true;
        if (mobileSeasonBack) mobileSeasonBack.inert = false;
      }
      aboutToggle?.setAttribute('aria-expanded', String(show));
      aboutToggle?.setAttribute('aria-controls', 'seronine-menu-about-20260907');
    };
    const setSeasonLevel = (open, focus = false) => {
      setAboutPanel(false);
      menu.classList.toggle('is-season-level', open);
      mobileShopToggle?.setAttribute('aria-expanded', String(open));
      seasonsNav?.setAttribute('aria-hidden', String(!open));
      if (seasonsNav) seasonsNav.inert = !open;
      if (mobileSeasonBack) mobileSeasonBack.inert = !open;
      if (focus) focusControl(open ? mobileSeasonBack : mobileShopToggle);
    };
    const positionMenu = () => {
      const nav = triggers[0].closest('nav');
      const rect = nav?.getBoundingClientRect();
      menu.style.setProperty('--seronine-season-menu-top', `${Math.ceil(Math.max(64, rect?.bottom || 64) + 16)}px`);
    };
    const setMenu = (open) => {
      window.clearTimeout(closeTimer);
      if (open) {
        returnFocus = document.activeElement;
        positionMenu();
        menu.inert = false;
        setCountryPanel(false);
        setSeasonLevel(false);
      }
      menu.classList.toggle('is-open', open);
      menu.setAttribute('aria-hidden', String(!open));
      document.documentElement.classList.toggle('seronine-season-menu-open-20260906', open);
      triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', String(open)));
      if (open) focusControl(panel);
      else {
        menu.inert = true;
        focusControl(returnFocus?.isConnected ? returnFocus : triggers[0]);
        closeTimer = window.setTimeout(() => { setCountryPanel(false); setSeasonLevel(false); }, 600);
      }
    };
    document.addEventListener('seronine:close-menu-for-search-20260907', () => {
      if (menu.classList.contains('is-open')) setMenu(false);
    });
    setCountryPanel(false);
    setSeasonLevel(false);
    desktop.addEventListener('change', () => {
      positionMenu();
      if (menu.classList.contains('is-open')) { setCountryPanel(false); setSeasonLevel(false); focusControl(mobileShopToggle); }
    });
    window.addEventListener('resize', positionMenu, { passive: true });

    triggers.forEach((trigger) => trigger.addEventListener('click', () => setMenu(!menu.classList.contains('is-open'))));
    menu.querySelectorAll('[data-seronine-menu-close-20260906]').forEach((control) => control.addEventListener('click', () => setMenu(false)));
    menu.querySelectorAll('[data-seronine-menu-search-20260906]').forEach((control) => control.addEventListener('click', () => setMenu(false)));
    // These are real page transitions, matching the reference behaviour. Close
    // the mobile drawer before the browser follows the destination link.
    menu.querySelectorAll('a[href]').forEach((link) => link.addEventListener('click', (event) => {
      if (link === aboutToggle && aboutPanel && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
        event.preventDefault(); setCountryPanel(false); setAboutPanel(true); focusControl(mobileSeasonBack); return;
      }
      setMenu(false);
    }));
    mobileShopToggle?.addEventListener('click', () => setSeasonLevel(true, !desktop.matches));
    mobileSeasonBack?.addEventListener('click', () => {
      const wasAbout = menu.classList.contains('is-about-open');
      setSeasonLevel(false);
      focusControl(wasAbout ? aboutToggle : mobileShopToggle);
    });
    countryToggle?.addEventListener('click', () => setCountryPanel(!menu.classList.contains('is-country-open')));
    // The mobile footer opens this exact country/currency surface so the
    // list, scrolling, arrow state and Update Location flow stay identical.
    document.addEventListener('seronine:open-country-picker-20260906', () => {
      setMenu(true);
      setCountryPanel(true);
    });
    document.addEventListener('click', (event) => {
      if (!event.target.closest('[data-seronine-footer-country-trigger-20260906]')) return;
      document.dispatchEvent(new CustomEvent('seronine:open-country-picker-20260906'));
    });
    countrySelect?.addEventListener('click', () => setCountryList(!menu.classList.contains('is-country-list-open')));
    menu.querySelectorAll('[data-seronine-country-option-20260906]').forEach((option) => option.addEventListener('click', () => {
      const name = option.getAttribute('data-country-name');
      const code = option.getAttribute('data-country-code');
      if (!name || !code) return;
      countrySelect.textContent = name;
      countryValue.value = code;
      countryUpdate.disabled = false;
      menu.querySelectorAll('[data-seronine-country-option-20260906]').forEach((item) => item.removeAttribute('aria-current'));
      option.setAttribute('aria-current', 'true');
      setCountryList(false);
    }));
    countryUpdate?.addEventListener('click', (event) => {
      event.preventDefault();
      if (countryForm.dataset.submitting === 'true') return;
      const destination = new URL(window.location.href);
      const selected = menu.querySelector('[data-seronine-country-option-20260906][aria-current="true"]');
      const country = selected?.getAttribute('data-country-code') || countryValue.value;
      destination.searchParams.set('country', country);
      destination.searchParams.delete('currency');
      if (window.Shopify?.theme?.role === 'unpublished') destination.searchParams.set('preview_theme_id', window.Shopify.theme.id);
      let returnInput = countryForm.querySelector('[name="return_to"]');
      if (!returnInput) { returnInput = document.createElement('input'); returnInput.type = 'hidden'; returnInput.name = 'return_to'; countryForm.appendChild(returnInput); }
      returnInput.value = destination.pathname + destination.search + destination.hash;
      countryValue.value = country;
      countryForm.dataset.submitting = 'true';
      countryUpdate.disabled = true;
      countryUpdate.textContent = 'UPDATING…';
      HTMLFormElement.prototype.submit.call(countryForm);
    });
    document.addEventListener('pointerdown', (event) => {
      if (!window.matchMedia('(min-width: 750px)').matches || !menu.classList.contains('is-open')) return;
      if (menu.contains(event.target) || triggers.some((trigger) => trigger.contains(event.target))) return;
      setMenu(false);
    });
    document.addEventListener('keydown', (event) => {
      if (!menu.classList.contains('is-open')) return;
      if (event.key === 'Tab') {
        const controls = [...menu.querySelectorAll('a[href], button:not(:disabled), input:not([type="hidden"])')]
          .filter((node) => !node.closest('[inert]') && node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden' && !node.classList.contains('seronine-season-menu-20260906__backdrop'));
        if (!controls.length) return;
        const first = controls[0], last = controls[controls.length - 1];
        if (event.shiftKey && (document.activeElement === first || !menu.contains(document.activeElement))) { event.preventDefault(); focusControl(last); }
        else if (!event.shiftKey && (document.activeElement === last || !menu.contains(document.activeElement))) { event.preventDefault(); focusControl(first); }
        return;
      }
      if (event.key !== 'Escape') return;
      event.preventDefault();
      if (menu.classList.contains('is-country-open')) setCountryPanel(false);
      else if (menu.classList.contains('is-about-open')) { setSeasonLevel(false); focusControl(aboutToggle); }
      else if (!desktop.matches && menu.classList.contains('is-season-level')) setSeasonLevel(false, true);
      else setMenu(false);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
